import DataGrid, { Column, Grouping, GroupItem, Sorting, Summary, TotalItem } from "devextreme-react/data-grid";
import ScrollView from "devextreme-react/scroll-view";
import Toolbar, { Item } from 'devextreme-react/toolbar';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Modal } from 'semantic-ui-react';
import { financeHelperApi } from "../../../../api/finance/financeHelperApi";
import { DefaultButton, PrimaryButton } from "../../../../components/editor/button";
import TBTPCreateKhoanNopSelection from '../khoan-nop-selection/TBTPCreateKhoanNopSelection';
import SendEmailModal from '../send-email/SendEmailModal';
import { useSelector } from "react-redux";

const EditTBTPKhoanNop = ({ sf_tinhbaophi_viewmodel, onSelected, onCancel, hocSinh }) => {
    const grid = useRef();
    const [sf_hinhthucnopboms_all, set_sf_hinhthucnopboms_all] = useState([]);
    const [sf_tinhbaophi_khoannops, set_sf_tinhbaophi_khoannops] = useState([]);
    const [sf_hinhthucnopbom_ids, set_sf_hinhthucnopbom_ids] = useState([]);
    const [sf_tinhbaophi_khoandanops, set_sf_tinhbaophi_khoandanops] = useState([]);
    const [sf_tinhbaophi_editing, set_sf_tinhbaophi_editing] = useState(sf_tinhbaophi_viewmodel);
    const [reloadDataComplete, setReloadDataComplete] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const [isShowSendEmailModal, setIsShowSendEmailModal] = useState(false);
    const { dm_coso_id } = useSelector((x) => x.coSo);

    const [isShowDetailModal, setIsShowDetailModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const sf_hinhthucnopbom = () => {
        const result = sf_tinhbaophi_khoannops && Array.from(new Set(sf_tinhbaophi_khoannops.map(x => x.sf_hinhthucnopbom_id)));
        if (result && result.length == 0) {
            return (sf_tinhbaophi_editing?.sf_hinhthucnopbom_ids ?? '').split(',').map(x => parseInt(x)).filter(x => x > 0);
        }
        set_sf_hinhthucnopbom_ids(result);

    };
    const handleReloadData = async () => {
        setIsLoading(true)

        const datasend = { ts_hocsinh_id: hocSinh.id, nam_hoc: hocSinh.nam_hoc }
        const res = await financeHelperApi.sf_tinhbaophi_selectbyhocsinh(datasend);
        if (res.is_success) {
            if (sf_tinhbaophi_editing && sf_tinhbaophi_editing.sf_tinhbaophi_khoannop_viewmodels !== undefined) {
                const filter = res.data.data.filter(x => x.id == sf_tinhbaophi_editing.id)[0];
                set_sf_tinhbaophi_khoannops(filter.sf_tinhbaophi_khoannop_viewmodels)
                set_sf_tinhbaophi_editing(filter);

            }
            else {
                set_sf_tinhbaophi_khoannops(res.data.data[0].sf_tinhbaophi_khoannop_viewmodels)
                set_sf_tinhbaophi_editing(res.data.data[0]);
            }
            setReloadDataComplete(true)
        } else {
            set_sf_tinhbaophi_editing([]);
            setReloadDataComplete(true)
        }
        setIsLoading(false)

    };
    const sf_hinhthucnopboms = useMemo(() => {
        if (sf_hinhthucnopbom_ids !== null && sf_hinhthucnopbom_ids !== undefined && sf_hinhthucnopbom_ids.length > 0) {
            return sf_hinhthucnopboms_all.filter(x => sf_hinhthucnopbom_ids.includes(x.id));
        }
        return sf_hinhthucnopboms_all;
    }, [sf_hinhthucnopboms_all, sf_hinhthucnopbom_ids])

    useEffect(() => {
        set_sf_tinhbaophi_editing(sf_tinhbaophi_viewmodel);
    }, [sf_tinhbaophi_viewmodel])

    useEffect(() => {
        sf_hinhthucnopbom();
    }, [sf_tinhbaophi_khoannops])
    useEffect(() => {
        handleReloadHinhThucNopBoms();
        set_sf_tinhbaophi_khoannops(sf_tinhbaophi_editing.sf_tinhbaophi_khoannop_viewmodels)
        if (sf_tinhbaophi_editing.sf_tinhbaophi_khoannop_viewmodels == undefined) {
            setIsShowDetailModal(true)
        }
    }, [reloadDataComplete])
    useEffect(() => {
        if (isLoading) {
            grid.current.instance.beginCustomLoading();
        } else {
            grid.current.instance.endCustomLoading();
        }
    }, [isLoading]);
    useEffect(() => {
        grid.current.instance.refresh();
    }, [dataSource]);
    const handleReloadHinhThucNopBoms = async () => {
        const res = await financeHelperApi.sf_hinhthucnopbom_select_all();
        if (res.is_success) {
            if (dm_coso_id == 1) {
                set_sf_hinhthucnopboms_all(res.data.data.filter(x => x.id > 0 && x.dm_coso_id == 1));
            } else {
                set_sf_hinhthucnopboms_all(res.data.data.filter(x => x.id > 0 && x.dm_coso_id != 1))
            }
            // set_sf_hinhthucnopboms_all(res.data.data)
        }
    }
    const handleShowDeleteConfirm = async (cell) => {
        const datasend = { sf_tinhbaophi_id: sf_tinhbaophi_editing.id, sf_khoannop_id: cell }
        const res = await financeHelperApi.sf_tinhbaophi_remove_khoannop(datasend);
        if (res.is_success) {
            // set_sf_hinhthucnopboms_all(res.data.data);
            handleReloadData();
        }
    }
    const btnAddKhoanNop_Click = () => {
        if (sf_tinhbaophi_editing && sf_tinhbaophi_editing.sf_tinhbaophi_khoannop_viewmodels !== undefined) {
            const khoanDaNops = sf_tinhbaophi_editing.sf_tinhbaophi_khoannop_viewmodels.map(x => x.sf_khoannop_id);
            set_sf_tinhbaophi_khoandanops(khoanDaNops)
        }
        else {
            set_sf_tinhbaophi_khoandanops([])
        }
        setIsShowDetailModal(true);
    }
    const btnExportClick = () => {
        if (grid && grid.current && grid.current.instance) {
            grid.current.instance.exportToExcel();
        }
    }
    const btnPreview_Click = () => {
        window.open(sf_tinhbaophi_editing.pdf_file, '_blank');

    }
    const btnSendEmail_Click = () => {
        setIsShowSendEmailModal(true);
    }
    useEffect(() => {
        if (reloadDataComplete || sf_tinhbaophi_editing) {
            const result = sf_tinhbaophi_khoannops && sf_tinhbaophi_khoannops.map(_sf_khoannop => {
                let item = { ..._sf_khoannop }
                for (let i = 0; i < sf_hinhthucnopboms.length; i++) {
                    const sf_hinhthucnopbom = sf_hinhthucnopboms[i];
                    const sf_tinhbaophi_khoannop_vm = sf_tinhbaophi_khoannops.find(x => x.sf_khoannop_id == item.sf_khoannop_id
                        && x.sf_hinhthucnopbom_id == sf_hinhthucnopbom.id)
                    if (sf_tinhbaophi_khoannop_vm) {
                        item[`DM_${sf_hinhthucnopbom.id}`] = sf_tinhbaophi_khoannop_vm.so_tien_dinh_muc;
                        item[`MG_${sf_hinhthucnopbom.id}`] = sf_tinhbaophi_khoannop_vm.so_tien_mien_giam;
                        item[`PN_${sf_hinhthucnopbom.id}`] = sf_tinhbaophi_khoannop_vm.so_tien_dinh_muc - sf_tinhbaophi_khoannop_vm.so_tien_mien_giam;
                    }
                }
                return item;
            });
            setDataSource(result);
        }
    }, [reloadDataComplete, sf_tinhbaophi_khoannops, sf_hinhthucnopboms]);

    const DynamicColumn = useMemo(() => {

        return sf_hinhthucnopboms.map((x, idx) => {
            return (
                <Column key={idx} caption={x.name} alignment={"center"} width={300}>
                    <Column dataField={`DM_${x.id}`} format=",##0" caption="Mức thu" width={120}></Column>
                    <Column dataField={`MG_${x.id}`} format=",##0" caption="Giảm trừ" width={120} cellRender={(cell) => {
                        if (cell.data[`MG_${x.id}`] !== 0) {
                            if (cell.data[`MG_${x.id}`]) {
                                return <div>{cell.data[`MG_${x.id}`].toLocaleString()}</div>
                            }
                        } else {
                            return <div>-</div>
                        }
                    }}></Column>
                    <Column dataField={`PN_${x.id}`} format=",##0" caption="Thành tiền" width={120}></Column>
                </Column>
            );
        })
    }, [sf_hinhthucnopboms]);

    const DynamicSummary = useMemo(() => {
        return <Summary>
            {sf_hinhthucnopboms.map((x, idx) => {
                return (
                    <GroupItem
                        key={idx}
                        column={`DM_${x.id}`}
                        summaryType="sum"
                        valueFormat=",##0"
                        showInGroupFooter={false}
                        displayFormat="{0}"
                        alignByColumn={true} />
                );
            })}
            {sf_hinhthucnopboms.map((x, idx) => {
                return (
                    <TotalItem
                        key={idx}
                        column={`DM_${x.id}`}
                        summaryType="sum"
                        valueFormat=",##0"
                        displayFormat="{0}"
                    />
                );
            })}
            {sf_hinhthucnopboms.map((x, idx) => {
                return (

                    <GroupItem
                        key={idx}
                        column={`MG_${x.id}`}
                        summaryType="sum"
                        valueFormat=",##0"
                        showInGroupFooter={false}
                        displayFormat="{0}"
                        customizeText={e => {
                            if (e.value !== 0) {
                                return e.value.toLocaleString();
                            } else {
                                return "-";
                            }

                        }}
                        alignByColumn={true} />
                );
            })}
            {sf_hinhthucnopboms.map((x, idx) => {
                return (

                    <TotalItem
                        key={idx}
                        column={`MG_${x.id}`}
                        summaryType="sum"
                        valueFormat=",##0"
                        displayFormat="{0}"
                        customizeText={e => {
                            if (e.value !== 0) {
                                return e.value.toLocaleString();
                            } else {
                                return "-";
                            }

                        }}
                    />
                );
            })}
            {sf_hinhthucnopboms.map((x, idx) => {
                return (

                    <GroupItem
                        key={idx}
                        column={`PN_${x.id}`}
                        summaryType="sum"
                        valueFormat=",##0"
                        showInGroupFooter={false}
                        displayFormat="{0}"
                        alignByColumn={true} />
                );
            })}
            {sf_hinhthucnopboms.map((x, idx) => {
                return (

                    <TotalItem
                        key={idx}
                        column={`PN_${x.id}`}
                        summaryType="sum"
                        valueFormat=",##0"
                        displayFormat="{0}"
                    />
                );
            })}
        </Summary>
    }, [sf_hinhthucnopboms]);


    return (
        <Modal
            open={true}
            dimmer={'blurring'}
            closeOnEscape={false}
            closeOnDimmerClick={false}
            size="large"
            width={1000}
        >
            <Modal.Header>
                <b style={{ flex: 1, fontWeight: "600" }}>Tính báo phí của {`${hocSinh.ma_hs} - ${hocSinh.ho_ten}`}</b>
            </Modal.Header>
            <Modal.Content>
                <Toolbar className='bg-background'>
                    <Item
                        location='after'
                        render={() => {
                            return (
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <PrimaryButton
                                        text="Thêm khoản nộp"
                                        type="normal"
                                        icon="fa fa-plus"
                                        id="btnAddKhoanNop"
                                        onClick={btnAddKhoanNop_Click}
                                        isLoading={isLoading}
                                    />

                                </div>
                            );
                        }}
                    />
                    {sf_tinhbaophi_editing.pdf_file &&
                        < Item
                            location='after'
                            render={() => {
                                return (
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <DefaultButton
                                            text="Preview"
                                            type="normal"
                                            icon="fa fa-eye"
                                            id="btnPreview"
                                            onClick={btnPreview_Click}
                                        />

                                    </div>
                                );
                            }}
                        />
                    }
                    {sf_tinhbaophi_editing.pdf_file &&
                        < Item
                            location='after'
                            render={() => {
                                return (
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <DefaultButton
                                            text="Gửi Email"
                                            type="normal"
                                            icon="icon send"
                                            id="btnSendemail"
                                            onClick={btnSendEmail_Click}
                                        />

                                    </div>
                                );
                            }}
                        />
                    }
                    <Item
                        location='after'
                        render={() => {
                            return (
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <DefaultButton
                                        text="Export"
                                        type="normal"
                                        icon="fas fa-file-export"
                                        id="btnAddKhoanNop"
                                        onClick={btnExportClick}
                                    />
                                </div>
                            );
                        }}
                    />
                </Toolbar>
                <div className="row">
                    <ScrollView width={"100%"} height={window.innerHeight - 250}>
                        <div>
                            <div className="row">
                                <div className="col-md-12">
                                    <DataGrid
                                        ref={grid}
                                        keyExpr={"sf_khoannop_id"}
                                        dataSource={dataSource}
                                        columnHidingEnabled={false}
                                        columnAutoWidth={true}
                                        showBorders={true}
                                        showColumnLines={true}
                                        showRowLines={true}
                                        rowAlternationEnabled={true}
                                        allowColumnResizing={true}
                                        columnResizingMode={"nextColumn"}
                                        hoverStateEnabled={true}
                                        focusedRowEnabled={false}
                                        noDataText="Không có dữ liệu"
                                        paging={{ enabled: false }}
                                        wordWrapEnabled={true}
                                        height={window.innerHeight - 260}
                                    >
                                        <Sorting mode="multiple" />
                                        <Column caption="Bỏ" alignment={"center"} width={100} cellRender={(cell) => {
                                            if (cell.data.sf_khoannop_id > 0) {
                                                return (
                                                    <a style={{ cursor: "pointer" }} onClick={() => {
                                                        handleShowDeleteConfirm(cell.data.sf_khoannop_id)
                                                    }}>
                                                        <i style={{ color: "#f32727" }} className="fas fa-trash"></i>
                                                    </a>
                                                );
                                            }
                                            return (
                                                <span></span>
                                            );
                                        }} />

                                        <Column dataField="ten_khoan_nop_group" caption="Nhóm" groupIndex={0} sortOrder={'asc'}></Column>
                                        <Column dataField="ma_khoan_nop" caption="Mã khoản nộp" width={120}></Column>
                                        <Column dataField="ten_khoan_nop" caption="Tên khoản nộp" minWidth={200}></Column>
                                        {DynamicColumn}
                                        {DynamicSummary}
                                        <Grouping
                                            autoExpandAll={false}
                                        />
                                    </DataGrid>
                                </div>
                            </div>
                        </div>

                    </ScrollView>



                    {isShowDetailModal && (
                        <TBTPCreateKhoanNopSelection
                            ts_hocsinh={hocSinh}
                            onSelected={() => {
                                handleReloadData();
                                setIsShowDetailModal(false);
                            }}
                            onCancel={() => {
                                setIsShowDetailModal(false);
                                if (sf_tinhbaophi_editing.sf_tinhbaophi_khoannop_viewmodels === undefined) {
                                    onCancel();
                                }
                            }}
                            sf_tinhbaophi_khoandanops={sf_tinhbaophi_khoandanops}
                            sf_hinhthucnopbom_ids={sf_hinhthucnopbom_ids}
                            sf_tinhbaophi_viewmodel={sf_tinhbaophi_editing}

                        />

                    )}
                    {isShowSendEmailModal && (
                        <SendEmailModal
                            ts_hocsinh={hocSinh}
                            onSelected={() => {
                                handleReloadData();
                                setIsShowSendEmailModal(false);
                            }}
                            onCancel={() => {
                                setIsShowSendEmailModal(false);
                                if (sf_tinhbaophi_editing.sf_tinhbaophi_khoannop_viewmodels === undefined) {
                                    onCancel();
                                }
                            }}
                            sf_tinhbaophi_editing={sf_tinhbaophi_editing}

                        />

                    )}
                </div>
            </Modal.Content>
            <Modal.Actions>
                <DefaultButton type="normal" text="Đóng" onClick={() => { onCancel() }} /> {' '}
            </Modal.Actions>
        </Modal>
    )
}
export default EditTBTPKhoanNop;